export * from '@primeuix/themes/material/tabmenu';
export { default } from '@primeuix/themes/material/tabmenu';
